import { Injectable } from '@angular/core';
import { SmartAssistService } from 'src/app/services/smart-assist/smart-assist.service';
import { LoggerService } from '../../logger/logger.service';

@Injectable({
	providedIn: 'root'
})
export class ActiveProtectionSystemService {
	constructor(
		private smartAssist: SmartAssistService,
		private logger: LoggerService
	) {}

	public isAvailable(): Promise<boolean> {
		return Promise.all([
			this.smartAssist.getAPSCapability(),
			this.smartAssist.getSensorStatus(),
			this.smartAssist.getHDDStatus()
		]).then(([apsCapability, sensorStatus, hddStatus]: any[]) => {
			this.logger.info(
				'APS Capability ---------------------------------',
				[apsCapability, sensorStatus, hddStatus]
			);
			return apsCapability && sensorStatus && hddStatus > 0;
		}).catch((error) => {
			this.logger.info('APS ERROR------------------', error.message);
			return false;
		});
	}
}
